import React from 'react';

import '@/stylesheets/WhiteBox.scss';

export default function WhiteBox({ children, className }) {
  return (
    <div className={`whiteBox ${className ? className : ''}`}>{children}</div>
  );
}